<template>
  <!-- <div id="app"> -->
  <div v-if="isLoading" ref="divLoading"
    :class="['loading d-flex flex-row align-items-center justify-content-center', layoutMode === 'dark' ? 'dark' : 'light']">
    <img :src="layoutMode === 'dark' ? loaderWhite : loaderBlack" alt="Loading" width="50">
  </div>
  <LoginModal v-if="showLoginModal && !isLogin" />
  <Layout></Layout>
  <!-- </div> -->
</template>

<style scoped>
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10001;
  text-align: center;
}

.loading.dark {
  background-color: #1a2a3d;
}

.loading.light {
  background-color: #f1f3f7;
}
</style>

<script>
import Layout from "./views/layouts/main.vue";
import appConfig from "@/app.config";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "vuex";
import LoginModal from '@/components/login-modal.vue';
import loaderBlack from '@/assets/images/loader-black.svg';
import loaderWhite from '@/assets/images/loader-white.svg';

export default {
  name: "App",
  components: {
    Layout,
    LoginModal
  },
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const divLoading = ref(null);
    const isLoading = ref(true);

    const isLogin = computed(() => route.name === 'login' || route.name === undefined);
    const showLoginModal = computed(() => store.state.auth.user === null);
    const layoutMode = store.state.layout.layoutMode;

    onMounted(async () => {
      await router.isReady();  // wait for full routing and page ready
      isLoading.value = false;
    });

    return {
      isLogin,
      isLoading,
      divLoading,
      layoutMode,
      loaderBlack,
      loaderWhite,
      pagetitle: route.meta.title,
      showLoginModal
    }
  },
};
</script>
